import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const createVDKEventLanguage = (payload) => {
    return vdkEmHappinessPortalApi.post('/vdk-event-languages/create', payload);
};
const updateVDKEventLanguage = (payload) => {
    return vdkEmHappinessPortalApi.put('/vdk-event-languages/update', payload);
};
const deleteVDKEventLanguage = (id) => {
    return vdkEmHappinessPortalApi.delete(`/vdk-event-languages/${id}`);
};
const getVDKEventLanguageById = (id) => {
    return vdkEmHappinessPortalApi.get(`/vdk-event-languages/${id}`);
};
const getVDKEventLanguagesByEventId = (eventId) => {
    return vdkEmHappinessPortalApi.get(`/vdk-event-languages-by-event-id/${eventId}`);
};
const getLanguagesForEvent = (eventId) => {
    const payload = { eventId };
    return vdkEmHappinessPortalApi.post('/vdkeventlanguages/get-all', payload);
};
const VDKEventLanguagesApi = {
    createVDKEventLanguage,
    updateVDKEventLanguage,
    deleteVDKEventLanguage,
    getVDKEventLanguageById,
    getVDKEventLanguagesByEventId,
    getLanguagesForEvent
};
export default VDKEventLanguagesApi;
